import { RightSideDefaultClassName } from 'app/src/features/Shopping/shared/utils'
import { shoppingApi } from 'app/src/services/welfareportal'
import { euroFormatterIt } from 'app/src/shared/helpers'
import { useTranslation } from 'react-i18next'

export function MultiVoucherUsageDetailRightPanelSide(props: {
  order: shoppingApi.OrderDetails
  requestedRefund?: number
  className?: string
}) {
  const { t } = useTranslation('shopping', { keyPrefix: 'Direct.MultiVoucher.Usage.Detail' })

  return (
    <div className={props.className ?? RightSideDefaultClassName}>
      <div className='col-span-12 mx-auto pl-12 lg:col-span-6 lg:pl-0'>
        {props.requestedRefund && (
          <>
            <div className='h-[28px]'>{t('priceDescription')}</div>
            <div className='mt-4 text-2xl font-bold'>{euroFormatterIt.format(props.requestedRefund)}</div>
          </>
        )}
      </div>
    </div>
  )
}
